/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import App from './App.vue';
import firebase from 'firebase';
import './firebase/firebaseConfig';
import 'firebase/auth';
import axios from "axios";
import Numeral from 'numeral';
import vueNumeralFilterInstaller from 'vue-numeral-filter';

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax);

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Axios
Vue.prototype.$http = axios
// Vue.prototype.$http = require("axios");

// Numeral
Vue.use(Numeral);

// Numeral Filter
Vue.use(vueNumeralFilterInstaller);

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css';

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// Vuesax Admin Filters
import './filters/filters'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer);

// PrismJS
// import 'prismjs'
// import 'prismjs/themes/prism-tomorrow.css'
// import './registerServiceWorker'

// Feather font icon
require('./assets/css/iconfont.css');

Vue.config.productionTip = false;

let app;
firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  }
});


//
// new Vue({
//     router,
//     store,
//     render: h => h(App)
// }).$mount('#app');
